import { render } from "./payementCancled.vue?vue&type=template&id=7955369c&scoped=true"
import script from "./payementCancled.vue?vue&type=script&lang=js"
export * from "./payementCancled.vue?vue&type=script&lang=js"

import "./payementCancled.vue?vue&type=style&index=0&id=7955369c&scoped=true&lang=css"

import exportComponent from "/srv/guestwaiterreportingfront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7955369c"]])

export default __exports__